import qs from 'querystringify'
import remote from './remote'

const URL = {
    //SEARCH: '/cms/event',
    //DELETE: '/cms/event',
    //ADD: '/cms/event',
    //UPDATE: '/cms/event'
    SEARCH: '/cms/manager/missing',
    DELETE: '/cms/manager/missing',
    ADD: '/cms/manager/missing',
    UPDATE: '/cms/manager/missing'
}

export default {
    searchEventAlarm (option) {
        let url = remote.getUrl(URL.SEARCH)

        if (option) {
            url = url + '?' + qs.stringify(option)
        }

        return remote.request({
            url: url
        })
    },
    removeEventAlarm (alarmId) {
        return remote.request({
            url: remote.getUrl(URL.DELETE),
            method: remote.METHOD.DELETE,
            headers: {
                'Content-Type': 'application/json'
            },
            data: Array.isArray(alarmId) ? alarmId : [alarmId],
        })
    },
    searchEventAlarmDetail (alarmId) {
        return remote.request({
            url: remote.getUrl(URL.SEARCH) + '/' + alarmId,
            timeout: 30000,
        })
    },
    updateEventAlarm (alarmId, alarm) {
        return remote.request({
            url: remote.getUrl(URL.UPDATE) + '/' + alarmId,
            method: remote.METHOD.POST,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            data: alarm,
            timeout: 30000
        })
    },
    EventAlarmAdd (alarm) {
        return remote.request({
            url: remote.getUrl(URL.ADD),
            method: remote.METHOD.POST,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            data: alarm,
            timeout: 30000
        })
    }
}
